module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_photowedding@3x-f47ad3bdbb2bc2d04fc2627e89f70e25.webp";